import { Format } from "./core/elements/format"
import { Tool } from "./tools/index"

let Slider = function (chart, position) {
	Tool.call(this, chart)

	var touchDragging = false

	var t = (this.thumb = new Format(chart))
	t.round = { x: 4, y: 4 }
	t.stroke.size = 0.5
	t.gradient.visible = false
	t.gradient.direction = "leftright"
	t.shadow.visible = false

	var f = (this.back = new Format(chart))
	f.fill = "white"
	f.gradient.visible = false
	f.stroke.fill = "darkgrey"
	f.round = { x: 4, y: 4 }

	var g = (this.grip = new Format(chart))
	g.round = { x: 4, y: 4 }
	g.stroke.fill = "rgb(20,20,20,1.0)"

	this.gripSize = 3

	var b = (this.bounds = { x: 10, y: 10, width: 200, height: 20 })
	this.transparent = false

	this.margin = 16 // %
	this.min = 0
	this.max = 100

	this.position = typeof position == "undefined" ? 50 : position

	this.useRange = false
	this.thumbSize = 8
	this.horizontal = true
	this.cursor = "pointer"
	this.delta = 0

	function contains(r, p) {
		return p.x >= r.x && p.x <= r.x + r.width && p.y >= r.y && p.y <= r.y + r.height
	}

	this.thumbRect = function (r) {
		var range = this.max - this.min,
			v = range > 0 ? (this.position - this.min) / range : 0

		if (this.horizontal) {
			r.width = this.thumbSize
			r.x = b.x + v * b.width - r.width * 0.5
			r.y = b.y
			r.height = b.height
		} else {
			r.height = this.thumbSize
			r.y = b.y + v * b.height - r.height * 0.5
			r.x = b.x
			r.width = b.width
		}
	}

	var r = {}

	this.gripRect = function (r) {
		if (this.horizontal) {
			var h = r.height * 0.2
			return {
				x: r.x - this.gripSize,
				y: r.y + r.height * 0.5 - h,
				width: 2 * this.gripSize,
				height: 2 * h
			}
		} else {
			var w = r.width * 0.2
			return {
				x: r.x + r.width * 0.5 - w,
				y: r.y - this.gripSize,
				width: 2 * w,
				height: 2 * this.gripSize
			}
		}
	}

	this.draw = function () {
		var d = this.horizontal ? b.height : b.width,
			m = d * this.margin * 0.01

		if (!this.transparent) {
			if (this.horizontal) this.back.rectangle(b.x, b.y + m, b.width, d - 2 * m)
			else this.back.rectangle(b.x + m, b.y, d - 2 * m, b.height)
		}

		if (this.onDrawThumb) this.onDrawThumb(this)

		this.thumbRect(r)

		if (this.invertThumb) {
			var th = this.thumb

			if (this.horizontal) {
				th.rectangle(b.x, b.y + m, r.x, b.height - 2 * m)
				th.rectangle(b.x + r.x + r.width, b.y + m, b.width, b.height - 2 * m)
			} else {
				th.rectangle(b.x + m, b.y, b.width - 2 * m, r.y)
				th.rectangle(b.x + m, b.y + r.y + r.height, b.width - 2 * m, b.height)
			}
		} else this.thumb.rectangle(r)

		if (this.useRange) {
			if (this.horizontal) {
				var r1 = this.gripRect(r)
				this.grip.rectangle(r1)
				r1.x += r.width
				this.grip.rectangle(r1)
			}
		}
	}

	this.clickAt = function (pos) {
		var off = this.horizontal ? b.x : b.y,
			s = this.horizontal ? b.width : b.height,
			ra = this.max - this.min,
			v

		v = this.min + Math.max(0, ((pos + this.delta - off) * ra) / s)

		if (v > this.max) v = this.max

		if (this.onChanging) {
			var v2 = this.onChanging(this, v)
			if (typeof v2 !== "undefined") v = v2
		}

		if (v < this.min) v = this.min
		else if (v > this.max) v = this.max

		this.chart.newCursor = this.cursor

		if (this.position != v) {
			this.position = v

			//requestAnimationFrame(function() { this.chart.draw(); });

			this.chart.draw()
		}
	}

	this.resized = function () {
		if (this.onChanging) this.onChanging(this, this.position)
		this.chart.draw()
		this.chart.newCursor = "col-resize"
	}
	this.chart.canvas.addEventListener("touchstart", e => {
		touchDragging = true
		e.preventDefault()
	})
	this.chart.canvas.addEventListener("touchend", e => {
		touchDragging = false
		e.preventDefault()
	})
	this.mousemove = function (p) {
		var s = this.horizontal ? b.width : b.height,
			pp = this.horizontal ? p.x : p.y,
			ra = this.max - this.min

		this.thumbRect(r)

		if (this.resizeBegin && pp < r.x + r.width) {
			var old = this.thumbSize,
				dif = r.x - pp,
				v2 = 0.5 * ((dif * ra) / s)
			this.thumbSize += dif
			this.position -= v2

			if (this.position < this.min) {
				this.position = this.min
				this.thumbSize = old
			}

			this.resized()
		} else if (this.resizeEnd && pp > r.x) {
			var dif2 = r.x + r.width - pp,
				v3 = 0.5 * ((dif2 * ra) / s)
			this.thumbSize -= dif2
			this.position -= v3
			this.resized()
		} else if (this.dragging || touchDragging) {
			this.clickAt(pp)
		} else {
			var ingrip = false

			if (this.useRange) {
				var r1 = this.gripRect(r)
				ingrip = contains(r1, p)
				if (!ingrip) {
					r1.x += r.width
					ingrip = contains(r1, p)
				}
			}

			if (ingrip) this.chart.newCursor = "col-resize"
			else if (contains(r, p)) this.chart.newCursor = this.cursor
		}
	}

	var p = { x: 0, y: 0 }

	this.mousedown = function (event) {
		this.thumbRect(r)
		this.chart.calcMouse(event, p)

		var r1 = this.gripRect(r)
		this.resizeBegin = this.useRange && contains(r1, p)
		r1.x += r.width

		this.resizeEnd = this.useRange && !this.resizeBegin && contains(r1, p)
		this.dragging = !this.resizeBegin && !this.resizeEnd && contains(r, p)

		if (!this.resizeBegin && !this.resizeEnd) {
			if (this.dragging) this.delta = this.horizontal ? r.x + r.width * 0.5 - p.x : r.y + r.height * 0.5 - p.y
			else if (contains(b, p)) {
				var tmp = this.horizontal ? r.width * 0.5 : r.height * 0.5
				this.delta = -tmp
				this.clickAt(tmp + (this.horizontal ? p.x : p.y))
			}
		}

		return this.dragging || this.resizeBegin || this.resizeEnd
	}

	this.clicked = function () {
		var d = this.dragging || this.resizeBegin || this.resizeEnd
		this.resizeBegin = this.resizeEnd = this.dragging = false
		this.delta = 0
		return d
	}

	this.mouseout = function () {
		this.resizeBegin = this.resizeEnd = this.dragging = false
	}
}

Slider.prototype = new Tool()

export { Slider }
